import DocumentHeader from '@/components/DocumentHeader';
import { Heading, Copy, Container } from './styled';
import { Row } from '@simplywallst/ui-core';
import ExclamationIconSVG from '@assets/images/icons/legacy/exclamation-triangle.svg';
import GlobalStyle from '@/styled/styled.default';

const Timeout = () => (
  <Row height="100vh" width="100vw">
    <GlobalStyle />
    <DocumentHeader title={'Page timed out'} titleSuffix="" />
    <Container
      justifyContent="center"
      alignItem="center"
      alignContent="center"
      displayFlex
      column
    >
      <ExclamationIconSVG width="80" height="80" />
      <Heading>The page took too long to load.</Heading>
      <Copy>
        Looks like the server is taking too long to respond, please try again in
        sometime.
      </Copy>
    </Container>
  </Row>
);

export default Timeout;
